let videoUrl = "https://vod.plaync.com/lineage2/update/2021/class";
let imageUrl = `${promokit.store('staticPath')}/promo/lineage2/event/2021/210512_deathknight/img/create/m/`;

const info = {
    0:{
        0:{
            0:{
                number:212,
                id:"human-male-death",
                video:`${videoUrl}/human-male-death.mp4`,
                image:`${imageUrl}/sele-img-human.png`
            },
            1:{
                number:0,
                id:"human-male-warrior",
                video:`${videoUrl}/human-male-warrior.mp4`,
                image:`${imageUrl}/sele-img-human.png`
            },
            2:{
                number:10,
                id:"human-male-wizard",
                video:`${videoUrl}/human-male-wizard.mp4`,
                image:`${imageUrl}/sele-img-human.png`
            }
        },
        1:{
            0:"",
            1:{
                number:0,
                id:"human-female-warrior",
                video:`${videoUrl}/human-female-warrior.mp4`,
                image:`${imageUrl}/sele-img-human.png`
            },
            2:{
                number:10,
                id:"human-female-wizard",
                video:`${videoUrl}/human-female-wizard.mp4`,
                image:`${imageUrl}/sele-img-human.png`
            }
        }
    },
    1:{
        0:{
            0:"",
            1:{
                number:18,
                id:"elf-male-warrior",
                video:`${videoUrl}/elf-male-warrior.mp4`,
                image:`${imageUrl}/sele-img-elf.png`
            },
            2:{
                number:25,
                id:"elf-male-wizard",
                video:`${videoUrl}/elf-male-wizard.mp4`,
                image:`${imageUrl}/sele-img-elf.png`
            }
        },
        1:{
            0:"",
            1:{
                number:18,
                id:"elf-female-warrior",
                video:`${videoUrl}/elf-female-warrior.mp4`,
                image:`${imageUrl}/sele-img-elf.png`
            },
            2:{
                number:25,
                id:"elf-female-wizard",
                video:`${videoUrl}/elf-female-wizard.mp4`,
                image:`${imageUrl}/sele-img-elf.png`
            }
        }
    },
    2:{
        0:{
            0:"",
            1:{
                number:31,
                id:"darkelf-male-warrior",
                video:`${videoUrl}/darkelf-male-warrior.mp4`,
                image:`${imageUrl}/sele-img-darkelf.png`
            },
            2:{
                number:38,
                id:"darkelf-male-wizard",
                video:`${videoUrl}/darkelf-male-wizard.mp4`,
                image:`${imageUrl}/sele-img-darkelf.png`
            }
        },
        1:{
            0:"",
            1:{
                number:31,
                id:"darkelf-female-warrior",
                video:`${videoUrl}/darkelf-female-warrior.mp4`,
                image:`${imageUrl}/sele-img-darkelf.png`
            },
            2:{
                number:38,
                id:"darkelf-female-wizard",
                video:`${videoUrl}/darkelf-female-wizard.mp4`,
                image:`${imageUrl}/sele-img-darkelf.png`
            }
        }
    },
    3:{
        0:{
            0:"",
            1:{
                number:44,
                id:"oak-male-warrior",
                video:`${videoUrl}/oak-male-warrior.mp4`,
                image:`${imageUrl}/sele-img-oak.png`
            },
            2:{
                number:49,
                id:"oak-male-wizard",
                video:`${videoUrl}/oak-male-wizard.mp4`,
                image:`${imageUrl}/sele-img-oak.png`
            }
        },
        1:{
            0:"",
            1:{
                number:44,
                id:"oak-female-warrior",
                video:`${videoUrl}/oak-female-warrior.mp4`,
                image:`${imageUrl}/sele-img-oak.png`
            },
            2:{
                number:49,
                id:"oak-female-wizard",
                video:`${videoUrl}/oak-female-wizard.mp4`,
                image:`${imageUrl}/sele-img-oak.png`
            }
        }
    },
    4:{
        0:{
            0:"",
            1:{
                number:53,
                id:"dwarf-male-warrior",
                video:`${videoUrl}/dwarf-male-warrior.mp4`,
                image:`${imageUrl}/sele-img-dwarf.png`
            },
            2:""
        },
        1:{
            0:"",
            1:{
                number:53,
                id:"dwarf-female-warrior",
                video:`${videoUrl}/dwarf-female-warrior.mp4`,
                image:`${imageUrl}/sele-img-dwarf.png`
            },
            2:""
        }
    },
    5:{
        0:{
            0:"",
            1:{
                number:123,
                id:"kamael-male-warrior",
                video:`${videoUrl}/kamael-male-warrior.mp4`,
                image:`${imageUrl}/sele-img-kamael.png`
            },
            2:""
        },
        1:{
            0:"",
            1:{
                number:123,
                id:"kamael-female-warrior",
                video:`${videoUrl}/kamael-female-warrior.mp4`,
                image:`${imageUrl}/sele-img-kamael.png`
            },
            2:""
        }
    },
    6:{
        0:"",
        1:{
            0:"",
            1:{
                number:182,
                id:"artea-female-warrior",
                video:`${videoUrl}/artea-female-warrior.mp4`,
                image:`${imageUrl}/sele-img-artea.png`
            },
            2:{
                number:183,
                id:"artea-female-wizard",
                video:`${videoUrl}/artea-female-wizard.mp4`,
                image:`${imageUrl}/sele-img-artea.png`
            }
        }
    }
};

export default info;


// WEBPACK FOOTER //
// ./src/js/create/video-info.js